import { ApiClient } from '../ApiClient';
import config from "../utils/config";
class ProductsApiClient {
    constructor(productsApiUrl) {
        this.apiClient = new ApiClient(productsApiUrl);
    }
    async search(query, abort) {
        return await this.apiClient.get(`/search?${new URLSearchParams(query)}`, abort);
    }
    getLatest(numberOfProducts = 16, categoryId = "", sortOrder = 1) {
        return this.apiClient.get(`/newest?numberOfProducts=${numberOfProducts}&categoryId=${categoryId}&sortOrder=${sortOrder}`);
    }
    getByIds(ids) {
        return this.apiClient.get("?rambaseIds=" + ids.join(","));
    }
}
const productsApiClient = new ProductsApiClient(config.productsApiUrl);
export default productsApiClient;
